const Keyword = function(props) {
	let {found, word, status, removeCallback} = props;
	let classes = `keyword-item ${status}`;

	return (
		<li className={classes}>{word} ({found}) <button className="keyword-remove" data-word={word} onClick={removeCallback} title="Remove from list">×</button></li>
	)
}
export default Keyword;